import { Box, Button, Divider, Input, Sheet, Typography } from "@mui/joy";
import { useVenueIDs } from "../../routes/venue";
import { useVenue } from "../../redux/venue/venueHooks";
import { useDispatch } from "react-redux";
import { setFormOpen, setSelectedVenueIDs } from "../../reducers/rhapsody";
import { useSeasons } from "../../redux/season/seasonHooks";

/**
 *
 * @returns {ReactElement} VenueGeneral page
 */
export function VenueGeneral() {
  const venueIDs = useVenueIDs();
  const { venue, isLoading } = useVenue(venueIDs);
  const { seasons } = useSeasons();
  const dispatch = useDispatch();

  return (
    <Box
      sx={{
        maxWidth: 600,
        width: "100%",
        flexDirection: "column",
        gap: 1,
        display: "flex",
        alignItems: "stretch",
        marginLeft: "auto",
        marginRight: "auto",
      }}
    >
      {venue.sourceID === 420 ? (
        <Box sx={{ display: "flex", justifyContent: "end" }}>
          <Button
            onClick={() => {
              dispatch(setSelectedVenueIDs(venueIDs));
              dispatch(setFormOpen({ isOpen: true, formID: "venue" }));
            }}
            variant="soft"
            color="neutral"
            startDecorator={<i className="fa-solid fa-pen"></i>}
          >
            Edit
          </Button>
        </Box>
      ) : (
        <></>
      )}
      <Box>
        <Typography level="body3">ABOUT THE VENUE</Typography>
        <Sheet variant="soft" sx={{ borderRadius: 8 }}>
          <Input
            readOnly
            slotProps={{ input: { style: { textAlign: "right" } } }}
            variant="soft"
            startDecorator={"ID:"}
            value={venue?.id}
          />
          <Divider />
          <Input
            readOnly
            slotProps={{ input: { style: { textAlign: "right" } } }}
            variant="soft"
            startDecorator={"Name:"}
            value={venue?.name}
          />
          <Divider />
          <Input
            readOnly
            slotProps={{ input: { style: { textAlign: "right" } } }}
            variant="soft"
            startDecorator={"Description:"}
            value={venue?.description}
          />
          <Divider />
          <Input
            readOnly
            slotProps={{ input: { style: { textAlign: "right" } } }}
            variant="soft"
            startDecorator={"Timezone:"}
            value={venue?.tzName}
          />
          <Divider />
          <Input
            readOnly
            slotProps={{ input: { style: { textAlign: "right" } } }}
            variant="soft"
            startDecorator={"Address:"}
            value={venue?.address}
          />
          <Divider />
          <Input
            readOnly
            slotProps={{ input: { style: { textAlign: "right" } } }}
            variant="soft"
            startDecorator={"City:"}
            value={venue?.city}
          />
          <Divider />
          <Input
            readOnly
            slotProps={{ input: { style: { textAlign: "right" } } }}
            variant="soft"
            startDecorator={"State:"}
            value={venue?.state}
          />
          <Divider />
          <Input
            readOnly
            slotProps={{ input: { style: { textAlign: "right" } } }}
            variant="soft"
            startDecorator={"Latitude:"}
            value={venue?.latitude}
          />
          <Divider />
          <Input
            readOnly
            slotProps={{ input: { style: { textAlign: "right" } } }}
            variant="soft"
            startDecorator={"Longitude:"}
            value={venue?.longitude}
          />
          <Divider />
          <Input
            readOnly
            slotProps={{ input: { style: { textAlign: "right" } } }}
            variant="soft"
            startDecorator={"information:"}
            value={venue?.information}
          />
        </Sheet>
      </Box>
    </Box>
  );
}
